<template>
  <transition name="modal-body">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header"> New Pot Size </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="pot_sizes"> Description: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="new_pot_size"
                    ref="description"
                    placeholder="Enter a pot size"
                    v-modal="description"
                  />
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreatePotSize",

  // DATA
  data: () => ({
    description: "",
  }),

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePotSize"]), // inventory.js

    _save() {
      if (!this.$refs.description.value) {
        alert("please enter a pot size"); // todo - place the correct references
        return;
      }

      // TODO - Create a variable for the data
      var item = {
        id: 0,
        active: true,
        description: this.$refs.description.value,
      };

      this.apiCreatePotSize(item);
      this.$emit("close");
    },

    // TODO -
    getPotSize() {
      if (this.inventory == null) {
        return "";
      } else {
        return this.description;
      }
    },

    clear() {
      this.description = "";
    },
  },

  // COMPONENTS
  components: {},
};
</script>
